module.exports = __webpack_public_path__ + "img/YE.254e44a8.png";